import { Tool } from '@procureai/agents';
import { ToolError, ToolLoading, ToolResult } from '@procureai/uix/ai';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';

type AskGlobalExternalSourcerToolOutput = {
  combinedResults: {
    source: 'webSearch' | 'externalSearch';
    title: string;
    summary: string;
    url: string;
    location?: string;
  }[];
};

export const AskGlobalExternalSourcerTool: ToolResultComponent<
  Tool.askExternalSourcer, // askGlobalExternalSourcer is wired to askExternalSourcer right now
  // TODO: Export schemas to @procureai/agents and re-use the exported schemas here
  unknown,
  AskGlobalExternalSourcerToolOutput
> = ({ tool }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'Chat.tools.askGlobalExternalSourcer' });

  switch (tool.state) {
    case 'input-available':
      return <ToolLoading label={t('call')} />;

    case 'output-error': {
      return <ToolError label={t('error')} />;
    }
    case 'output-available': {
      const results = tool.output.combinedResults || [];

      return (
        <ToolResult
          label={t('result', {
            count: results.length,
          })}
          defaultOpen={false}
          disabled
        />
      );
    }
  }
};
